import { useQuery } from '@tanstack/react-query';

import {
  getMamAssets,
  getMamAssetsPermissions,
  getMamAssetUrl,
  MamAssetsApiKeysEnum,
} from '~services/api/calls/mam-assets';
import { ApiErrorDescriptor } from '~services/api/helpers';

export const useMamAssets = (mamAssetIds: number[], options?: UseQueryOptionsBase<MamAssetsDto, ApiErrorDescriptor>) =>
  useQuery({
    queryKey: [MamAssetsApiKeysEnum.GetMamAssets, ...mamAssetIds],
    queryFn: async () => {
      if (mamAssetIds?.length) {
        return await getMamAssets(mamAssetIds);
      }
      return [];
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
    ...options,
  });

export const useMamAssetUrl = (mamAssetId: number, options?: UseQueryOptionsBase<string, ApiErrorDescriptor>) =>
  useQuery({
    queryKey: [MamAssetsApiKeysEnum.GetMamAssetUrl, mamAssetId],
    queryFn: async () => {
      if (mamAssetId) {
        const dto = await getMamAssetUrl(mamAssetId);
        return dto.url;
      }
      return '#';
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: false,
    refetchOnWindowFocus: false,
    ...options,
  });

export const useMamPermissions = (mamAssetId: number, options?) =>
  useQuery({
    queryKey: ['permissions', mamAssetId],
    queryFn: async () => {
      return await getMamAssetsPermissions(mamAssetId);
    },
    retry: false,
    ...options,
  });
